import { render } from "./Convenzioni.vue?vue&type=template&id=3ca4c611&scoped=true"
import script from "./Convenzioni.vue?vue&type=script&lang=js"
export * from "./Convenzioni.vue?vue&type=script&lang=js"

import "./Convenzioni.vue?vue&type=style&index=0&id=3ca4c611&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca4c611"]])

export default __exports__